export default function DeleteAccount() {
    return (
        <div className="min-h-screen bg-gray-50 py-10 px-4">
            <div className="max-w-3xl mx-auto bg-white p-8 rounded-xl shadow">
                <h1 className="text-3xl font-bold mb-4">Account Deletion</h1>

                <p className="mb-4">
                    Users can delete their MyBioTick account directly from within the app.
                </p>

                <h2 className="text-xl font-semibold mt-6 mb-2">
                    How to delete your account
                </h2>

                <ol className="list-decimal pl-6 space-y-2">
                    <li>Open the MyBioTick app</li>
                    <li>Sign in with your Google account</li>
                    <li>Go to <strong>Profile → Delete Account</strong></li>
                    <li>Confirm deletion</li>
                </ol>

                <h2 className="text-xl font-semibold mt-6 mb-2">
                    What happens when you delete your account
                </h2>

                <ul className="list-disc pl-6 space-y-2">
                    <li>Your account is permanently deleted</li>
                    <li>All personal and medical data is erased</li>
                    <li>Doctor access is revoked immediately</li>
                </ul>

                <p className="mt-4">
                    If you are unable to access the app and need assistance,
                    contact us at:
                </p>

                <p className="mt-2 font-semibold">
                    Email: naveen011214@gmail.com
                </p>
            </div>
        </div>
    );
}